/* Theme JS — cart drawer, variant picker, gallery */
(function(){
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => Array.from(c.querySelectorAll(s));

  const moneyFormat = (cents) => {
    const n = (cents/100);
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(n); }
    catch { return '$'+n.toFixed(2); }
  };

  /* Cart drawer */
  const drawer = $('#CartDrawer');
  const openDrawer = () => { drawer.hidden = false; refreshCart(); };
  const closeDrawer = () => { drawer.hidden = true; };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });

  async function refreshCart(){
    const res = await fetch('/cart.js', {headers:{Accept:'application/json'}});
    const cart = await res.json();
    renderCart(cart);
    updateCount(cart.item_count);
  }
  function updateCount(n){
    $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = !n; });
  }
  function renderCart(cart){
    const body = $('[data-cart-body]');
    const footer = $('[data-cart-footer]');
    if (!cart.items.length){
      body.innerHTML = '<p class="cart-drawer__empty">Your selection is empty.</p>';
      footer.hidden = true; return;
    }
    body.innerHTML = cart.items.map(it => `
      <div class="cart-line">
        <img src="${it.image || ''}" alt="">
        <div>
          <div class="cart-line__title">${it.product_title}</div>
          <div class="cart-line__meta">${it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : ''}</div>
          <div class="cart-line__qty">
            <button data-qty="${it.key}" data-delta="-1" aria-label="Decrease">−</button>
            <span>${it.quantity}</span>
            <button data-qty="${it.key}" data-delta="1" aria-label="Increase">+</button>
          </div>
          <a class="cart-line__remove" href="#" data-remove="${it.key}">Remove</a>
        </div>
        <div>${moneyFormat(it.final_line_price)}</div>
      </div>
    `).join('');
    $('[data-cart-subtotal]').textContent = moneyFormat(cart.total_price);
    footer.hidden = false;
  }
  document.addEventListener('click', async e => {
    const qbtn = e.target.closest('[data-qty]');
    const rem = e.target.closest('[data-remove]');
    if (qbtn){
      const key = qbtn.dataset.qty, delta = parseInt(qbtn.dataset.delta,10);
      const cur = parseInt(qbtn.parentElement.querySelector('span').textContent,10);
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,cur+delta)})});
      refreshCart();
    }
    if (rem){
      e.preventDefault();
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:rem.dataset.remove,quantity:0})});
      refreshCart();
    }
  });

  /* Add to cart */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const items = [{id: fd.get('id'), quantity: parseInt(fd.get('quantity')||'1',10)}];
    const cardVariant = fd.get('card_variant_id');
    if (cardVariant) items.push({id: cardVariant, quantity: 1});
    const btn = form.querySelector('[type=submit]');
    btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…';
    try {
      await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
      await refreshCart();
      openDrawer();
    } catch (err){ console.error(err); }
    finally { btn.disabled = false; btn.textContent = btn.dataset.label; }
  });

  /* Variant picker */
    function swapMainImage(root, src, zoom, alt){
    if (!src) return;
    const mainWrap = root.querySelector('[data-main-image]');
    if (!mainWrap) return;
    let main = mainWrap.querySelector('img');
    if (!main){ main = document.createElement('img'); mainWrap.prepend(main); }
    main.src = src;
    if (zoom) main.setAttribute('data-zoom-src', zoom);
    if (alt) main.alt = alt;
    const thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.thumb === src));
  }

  document.addEventListener('change', e => {
    const input = e.target.closest('[data-option-input]');
    if (!input) return;
    const root = input.closest('[data-product-root]');
    if (!root) return;
    const selected = Array.from(root.querySelectorAll('[data-option-input]:checked')).map(i => i.value);
    const variants = JSON.parse(root.dataset.variants);
    const match = variants.find(v => JSON.stringify(v.options) === JSON.stringify(selected));
    // image swap: prefer exact match; otherwise first variant containing the changed value with an image
    let imgVariant = match && match.image ? match : null;
    if (!imgVariant){
      imgVariant = variants.find(v => v.image && v.options.indexOf(input.value) !== -1);
    }
    if (imgVariant && imgVariant.image) swapMainImage(root, imgVariant.image.src, imgVariant.image.zoom, imgVariant.image.alt);
    if (!match) return;
    root.querySelector('[name=id]').value = match.id;
    const priceEl = root.querySelector('[data-price]');
    if (priceEl) priceEl.textContent = moneyFormat(match.price);
    const submit = root.querySelector('[type=submit]');
    if (submit){ submit.disabled = !match.available; submit.textContent = match.available ? 'Add to selection' : 'Sold out'; }
    // update displayed label
    $$('[data-selected-for]', root).forEach((el,i) => { el.textContent = selected[i] || ''; });
  });

  /* Gallery thumbnail switching */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    e.preventDefault();
    const root = t.closest('[data-product-root]') || document;
    const mainWrap = root.querySelector('[data-main-image]');
    if (!mainWrap) return;
    let main = mainWrap.querySelector('img');
    if (!main) {
      main = document.createElement('img');
      mainWrap.prepend(main);
    }
    main.src = t.dataset.thumb;
    if (t.dataset.thumbZoom) main.setAttribute('data-zoom-src', t.dataset.thumbZoom);
    $$('[data-thumb]', root).forEach(b => b.classList.toggle('is-active', b === t));
  });

  /* Hover-to-zoom on main product image */
  $$('[data-zoom]').forEach(wrap => {
    const img = wrap.querySelector('img');
    if (!img) return;
    wrap.addEventListener('mousemove', e => {
      const r = wrap.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });
    wrap.addEventListener('mouseenter', () => wrap.classList.add('is-zooming'));
    wrap.addEventListener('mouseleave', () => {
      wrap.classList.remove('is-zooming');
      img.style.transformOrigin = 'center center';
    });
  });

  /* Fullscreen lightbox */
  const lb = $('[data-lightbox]');
  const lbImg = $('[data-lightbox-img]');
  const openLightbox = (src) => {
    if (!lb || !lbImg || !src) return;
    lbImg.src = src;
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
  };
  const closeLightbox = () => {
    if (!lb) return;
    lb.hidden = true;
    document.body.style.overflow = '';
  };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-lightbox]')) {
      e.preventDefault();
      const main = $('[data-main-image] img');
      openLightbox(main?.getAttribute('data-zoom-src') || main?.src);
    }
    if (e.target.closest('[data-lightbox-close]') || e.target === lb) closeLightbox();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLightbox(); });

  /* Mobile nav */
  const mnav = $('[data-mobile-nav]');
  const openMobileNav = () => { if (mnav){ mnav.hidden = false; document.body.style.overflow='hidden'; } };
  const closeMobileNav = () => { if (mnav){ mnav.hidden = true; document.body.style.overflow=''; } };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMobileNav(); }
    const closeTarget = e.target.closest('[data-menu-close]');
    if (closeTarget) {
      closeMobileNav();
      if (closeTarget.tagName !== 'A') e.preventDefault();
    }
  });

  /* Init cart count */
  fetch('/cart.js').then(r=>r.json()).then(c => updateCount(c.item_count));

  /* Hero carousel */
  $$('[data-hero-carousel]').forEach(root => {
    const track = $('[data-hero-track]', root);
    const slides = $$('.hero-carousel__slide', track);
    const dots = $$('[data-hero-dot]', root);
    if (slides.length <= 1) return;
    let idx = 0, timer = null;
    const autoplay = root.dataset.autoplay === 'true';
    const interval = parseInt(root.dataset.interval, 10) || 6000;
    const go = i => {
      idx = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${idx*100}%)`;
      dots.forEach((d,di) => d.classList.toggle('is-active', di === idx));
    };
    const start = () => { if (autoplay) timer = setInterval(() => go(idx+1), interval); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    $('[data-hero-prev]', root)?.addEventListener('click', () => { stop(); go(idx-1); start(); });
    $('[data-hero-next]', root)?.addEventListener('click', () => { stop(); go(idx+1); start(); });
    dots.forEach((d,di) => d.addEventListener('click', () => { stop(); go(di); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });

  /* Collection tabs */
  $$('[data-collection-tabs]').forEach(root => {
    const tabs = $$('.collection-tabs__tab', root);
    const panels = $$('.collection-tabs__panel', root);
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tabTarget;
        tabs.forEach(t => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
        panels.forEach(p => { const on = p.id === target; p.classList.toggle('is-active', on); p.hidden = !on; });
      });
    });
  });
})();
